import styled from 'styled-components';

import { BodyXSmallMedium, Colour, TextEllipsis } from '@xemplo/style-constants';

export const ListGroup = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  outline: none;
  border: none;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.li.attrs({ role: 'option' })`
  align-items: center;
  align-self: stretch;
  background: ${Colour.Light[100]};
  border-bottom: 1px solid ${Colour.Gray[200]};
  color: ${Colour.Gray[500]};
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 48px;
  outline: none;
  padding: 0px 24px;

  &.no-result {
    pointer-events: none;
    border-bottom: none;
  }

  &.selected {
    color: ${Colour.Blue[600]};
    background: ${Colour.Blue[50]};
    font-weight: 500;
  }

  &:hover:not(.selected, .no-result) {
    background: ${Colour.Gray[50]};
  }

  &:focus-visible {
    background: ${Colour.Gray[50]};
  }

  &.destructive {
    color: ${Colour.Clarity.Red.Hard};
  }

  &.destructive:hover:not(.no-result) {
    background: ${Colour.Clarity.Grey.ExtraSoft};
    color: ${Colour.Clarity.Red.Hard};
  }

  &.destructive.selected {
    color: ${Colour.Clarity.Red.Hard};
    background: ${Colour.Clarity.Background.Surface};
  }
`;

export const ListHeader = styled.h3`
  ${BodyXSmallMedium};
  box-sizing: border-box;
  align-items: center;
  background: ${Colour.Light[100]};
  color: ${Colour.Gray[300]};
  display: flex;
  gap: 8px;
  outline: none;
  padding: 20px 24px 8px 24px;
  pointer-events: none;
  text-transform: uppercase;
  margin: 0;
`;

export const ListItemText = styled.span`
  ${TextEllipsis};

  &.tags:not(.no-result) {
    background: ${Colour.Gray[100]};
    color: ${Colour.Gray[500]};
    border-radius: 4px;
    padding-inline: 8px;
    height: 24px;
    ${BodyXSmallMedium};
    line-height: 24px;
  }
`;

export const ListItemIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const AddTagWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  border-top: 1px solid ${Colour.Gray[200]};
  background: ${Colour.Light[100]};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  transition: all 0.2s ease-out;
  gap: 4px;

  &:hover {
    background: ${Colour.Gray[100]};
    cursor: pointer;
  }
`;
